import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions  } from '@angular/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { ApiSettings } from '../../api.settings';

@Injectable()
export class ConsignmentProductService {

  private consignmentProductUrl = ApiSettings.API_URL + 'consignmentProduct';
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers, withCredentials: true });

  constructor(private http: Http, private router: Router) { };

  parseParams(params: any){
    params = this.cleanEmptyParams(params);  
    let query : string = "?";
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            if (JSON.stringify(params[key])[0] === '{'){
                query += key +"="+ JSON.stringify(params[key])+'&';
            }else{
                query += key +"="+ params[key];
            }
        }
    }
    if (query[query.length-1] === '&'){
        query = query.substring(0,query.length-1);
    }
    return query;
 }

  query(params: any): Observable<any> {
      return this.http.get(this.consignmentProductUrl + this.parseParams(params), this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  get(id: number): Observable<any> {
      return this.http.get(this.consignmentProductUrl +'/'+ id, this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  create(consignmentProduct: any): Observable<any> {
      return this.http.post(this.consignmentProductUrl, consignmentProduct, this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  update(consignmentProduct: any): Observable<any> {
      return this.http.put(this.consignmentProductUrl +'/'+ consignmentProduct.id, consignmentProduct, this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  delete(id: number): Observable<any> {
      return this.http.delete(this.consignmentProductUrl +'/'+ id, this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  private cleanEmptyParams(params){
      if (params && params.where) {
          for (var filter in params.where) {
              if (!params.where[filter].contains && params.where[filter].contains === "") {
                  delete params.where[filter];
              }
          }
      }
      return params;
  }


  private extractData(res: Response) {
      let body = res.json();
      return body || { };
  }

  private handleError (error: Response | any) {
      if (error.status === 403){
          this.router.navigate(['/login']);
      }
      return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/consignment/services/consignment-product.service.ts